var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn vld-parent custom-100"},[_c('b-row',{staticClass:"custom-flex-1"},[_c('b-col',{attrs:{"sm":"12"}},[_c('auftraegeTable',{ref:"auftraegeTable",attrs:{"table-data":_vm.data,"show-icon":false}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }